import { UAParser } from 'ua-parser-js';

const extractMajorVersion = (version?: string) => (version ?? '').split('.')[0];

export const appendUserAgentData = <TInput>(input: TInput, parser = new UAParser()): TInput => {
  const parserData = parser.getResult();

  const data = {
    ...input,
    ua: {
      browser: {
        name: parserData.browser.name ?? '',
        version: extractMajorVersion(parserData.browser.version),
      },
      engine: {
        name: parserData.engine.name,
        version: extractMajorVersion(parserData.engine.version),
      },
      os: {
        name: parserData.os.name,
        version: extractMajorVersion(parserData.os.version),
      },
      device: {
        model: parserData.device.model,
        type: parserData.device.type,
        vendor: parserData.device.vendor,
      },
    },
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      viewportWidth: window.visualViewport?.width,
      viewportHeight: window.visualViewport?.height,
    },
  };

  return data;
};
